// components/admin/AdminSidebar.js
import React from 'react';
import { LayoutDashboard, ShoppingBag, Flower2, Users, UserCircle, LogOut } from 'lucide-react';

const AdminSidebar = ({ menuItems, currentPage, onPageChange, user, onLogout }) => {
  const getIcon = (id) => {
    switch(id) {
      case 'dashboard': return <LayoutDashboard size={20} />;
      case 'orders': return <ShoppingBag size={20} />;
      case 'products': return <Flower2 size={20} />;
      case 'staff': return <Users size={20} />;
      case 'profile': return <UserCircle size={20} />;
      default: return <LayoutDashboard size={20} />;
    }
  };

  return (
    <aside style={{ width: 280, background: '#0f172a', color: '#e2e8f0', height: '100%', display: 'flex', flexDirection: 'column', boxShadow: '2px 0 8px rgba(0,0,0,0.1)' }}>
      <div style={{ padding: '24px 20px', borderBottom: '1px solid #1e293b', marginBottom: 20 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 40, height: 40, background: '#2874f0', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '1.2rem', color: 'white' }}>B</div>
          <div><div style={{ fontWeight: 700, fontSize: '1.1rem', color: 'white' }}>Sugandhi</div><div style={{ fontSize: '0.7rem', color: '#64748b' }}>Admin Portal</div></div>
        </div>
      </div>

      <nav style={{ flex: 1, padding: '0 12px' }}>
        {menuItems.map(item => (
          <button key={item.id} onClick={() => onPageChange(item.id)} style={{
            width: '100%', padding: '12px 16px', marginBottom: 4, borderRadius: 10, border: 'none',
            background: currentPage === item.id ? '#1e293b' : 'transparent',
            color: currentPage === item.id ? '#2874f0' : '#94a3b8',
            display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer', transition: 'all 0.2s',
            fontSize: '0.9rem', fontWeight: currentPage === item.id ? 500 : 400
          }} onMouseEnter={(e) => { if (currentPage !== item.id) { e.currentTarget.style.background = '#1e293b'; e.currentTarget.style.color = '#e2e8f0'; } }}
             onMouseLeave={(e) => { if (currentPage !== item.id) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#94a3b8'; } }}>
            {getIcon(item.id)}<span>{item.label}</span>
          </button>
        ))}
      </nav>

      <div style={{ padding: 20, borderTop: '1px solid #1e293b', marginTop: 'auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16, padding: 8, background: '#1e293b', borderRadius: 10 }}>
          <div style={{ width: 36, height: 36, borderRadius: 8, background: '#2874f0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 600, color: 'white' }}>{user?.name?.[0]?.toUpperCase() || 'A'}</div>
          <div style={{ flex: 1, minWidth: 0 }}><div style={{ fontSize: '0.85rem', fontWeight: 600, color: 'white' }}>{user?.name || 'Admin'}</div><div style={{ fontSize: '0.7rem', color: '#64748b' }}>{user?.email}</div></div>
        </div>
        <button onClick={onLogout} style={{ width: '100%', padding: 10, background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.2)', borderRadius: 8, color: '#f87171', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, cursor: 'pointer', fontSize: '0.85rem', fontWeight: 500, transition: 'all 0.2s' }}
          onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(239,68,68,0.2)'; e.currentTarget.style.borderColor = 'rgba(239,68,68,0.4)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(239,68,68,0.1)'; e.currentTarget.style.borderColor = 'rgba(239,68,68,0.2)'; }}>
          <LogOut size={16} /> Sign Out
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;